import { useSelector } from "react-redux";
import MainContainer from "../../components/MainContainer/MainContainer";
import SEO from "../../components/SEO/SEO";
import CourseCard from "../../components/CourseCard";
import {
  PageHeader,
  CoursesSection,
  CoursesGrid,
  MiniSection,
  MiniDivider,
  MiniGrid,
} from "./CoursesPage.styles";
import {
  selectCourses,
  selectCoursesLoading,
  selectCoursesError,
} from "../../store/slices/courses/slice";

// Main CoursesPage Component
const CoursesPage = () => {
  // Redux selectors
  const courses = useSelector(selectCourses);
  const coursesLoading = useSelector(selectCoursesLoading);
  const coursesError = useSelector(selectCoursesError);

  // Razdvoj pune edukacije od mini edukacija (zasebna sekcija dole)
  const fullCourses = courses.filter((course) => !course.isMini);
  const miniCourses = courses.filter((course) => course.isMini);

  return (
    <MainContainer>
      <SEO
        title="Svi kursevi"
        description="Sve online edukacije na jednom mestu — Lash Lift, Brow Lift i kombinovani paketi. Video lekcije, PDF skripta i sertifikat nakon završene obuke."
        path="/kursevi"
      />

      {/* Page Header */}
      <PageHeader>
        <h1>Svi Kursevi</h1>
        <p>
          Postani sertifikovan Lash i Borw Lift artist i nauči najtraženije
          tehnike koje otvaraju vrata uspešne beauty karijere.
        </p>
      </PageHeader>

      {/* Mini edukacije — zasebna sekcija sa širokim karticama (prva na stranici) */}
      {!coursesLoading && !coursesError && miniCourses.length > 0 && (
        <MiniSection>
          <MiniDivider>
            <span>
              Mini edukacije <small>Novo</small>
            </span>
          </MiniDivider>
          <MiniGrid>
            {miniCourses.map((course) => (
              <CourseCard
                key={course.id}
                course={course}
                variant="wide"
                animate={true}
                offMaxWidth={true}
              />
            ))}
          </MiniGrid>
        </MiniSection>
      )}

      {/* Courses Section */}
      <CoursesSection>
        <CoursesGrid>
          {coursesLoading ? (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 16,
              }}
            >
              <l-line-spinner
                size="32"
                stroke="3"
                speed="1"
                color="var(--accent)"
              />

              <div>Učitavanje kurseva...</div>
            </div>
          ) : coursesError ? (
            <div>Greška pri učitavanju kurseva: {coursesError}</div>
          ) : courses.length === 0 ? (
            <div>Nema dostupnih kurseva.</div>
          ) : (
            fullCourses.map((course) => (
              <CourseCard
                key={course.id}
                course={course}
                variant="coursepage"
                animate={true}
              />
            ))
          )}
        </CoursesGrid>
      </CoursesSection>
    </MainContainer>
  );
};

export default CoursesPage;
